
import { defineComponent, PropType, toRefs } from 'vue';
import { formatTS } from '@/utility';
import { RouterLink } from 'vue-router';

import { RocknutModel } from '@/typings';
import { UserTag, StyleTag } from '@/components/common';

import { online_link_name } from '@/basics/enums';

import { useExpand } from './hooks';

export default defineComponent({
    components: {
        UserTag,
        StyleTag,
        RouterLink
    },
    props: {
        article: {
            type: Object as PropType<RocknutModel>,
            required: true
        },
        full: {
            type: Number,
            default: 1
        },
        showAlbum: {
            type: Boolean,
            default: false
        }
    },

    setup (props) {
        const {
            article
        } = toRefs(props);
        const { expand, is_expanded, counter_view } = useExpand(article.value);

        return {
            expand,
            is_expanded,
            counter_view,
            formatTS,
            online_link_name
        };
    }
});

